<template>
  <div class="row col-12 col-md-8 d-flex justify-content-center justify-content-md-start pl-md-0 mt-3 mt-md-0 pr-under-md-0 pl-under-md-0">
    <div class="col-12 pl-0 pr-0 mb-1">
      <b-form class="d-flex w-100">
        <b-input-group
          class="mb-2 w-100 annonce-create-search-bar"
          size="sm">
          <b-input-group-append>
            <b-input-group-text class="search-input-append">
              <i class="ph-custom ph-magnifying-glass"/>
            </b-input-group-text>
          </b-input-group-append>
          <b-form-input
            class="search-input"
            :class="{'active': searchInput}"
            v-model="searchInput"
            type="search"
            maxlength="250"
            :placeholder="$t('Research')">
          </b-form-input>
        </b-input-group>
      </b-form>
    </div>
    <div v-if="selectedBrand.invalidFeedback" class="d-block col-12 pl-0 pr-0 invalid-feedback mb-2">{{selectedBrand.invalidFeedback}}</div>
    <div id="annonce-create-items-list" class="item-container-annonce styled-scrollbar-custom" v-show="filteredBrands.length !== 0 && !isLoadingBrands">
      <div id="annonce-create-items-list-around">
        <transition-group name="listCustomTransition" tag="div" id="annonce-create-items-list-inside" class="item-container-annonce">
          <div  v-show="filteredBrands.length > 0" class="item-annonce cursor-pointer" :class="{'item-active': selectedBrand.value === brand.id, 'item-invalid': selectedBrand.invalidFeedback}" v-for="brand in filteredBrands" :key="brand.id" @click="setSelectedBrand(brand.id)">
            <div class="d-flex justify-content-center align-items-center text-center">{{brand.name}}</div>
          </div>
        </transition-group>
      </div>
    </div>
    <div id="annonce-create-items-list-empty" v-show="!isLoadingBrands && filteredBrands.length === 0" class="w-100 styled-scrollbar-custom">
      <div class="empty-state-container">
        <div id="empty-state-container-img-part" class="text-center pb-2">
          <img :src="require(`@/assets/images/b122/img-confused.png`)" alt="no result" class="empty-state-img">
        </div>
        <div id="empty-state-container-text-part" class=" text-center no-result-text">
          <div class="no-result-title mb-2">{{ $t('annonce.empty.brand.emptyTitle') }}</div>
          <div class="no-result-subtitle my-2">{{ $t('annonce.empty.brand.emptyText') }}</div>
          <b-button class="mr-1 mt-2" variant="primary" @click="$bvModal.show('create-vehicle-generic')">
            <div class="pr-4 pl-4">{{$t('annonce.empty.brand.emptyButton')}}</div>
          </b-button>
        </div>
      </div>
    </div>
    <div id="annonce-create-items-list-loading" v-show="isLoadingBrands" class="w-100 styled-scrollbar-custom">
      <div class="w-100 d-flex justify-content-center mt-4">
        <b-spinner class="list-spinner"></b-spinner>
      </div>
    </div>
    <annonce-create-vehicle-generic-modal
      :initial-name="searchInput"
      @returnCreateCustom="getCreatedCustom"
      label-input="annonce.empty.create.brand.label"
      title-modal="annonce.empty.create.brand.title"
      controller-name="brand"
      method-name="createCustomBrand"
      :vehicle-type-id="this.annonce.vehicleType.value">
    </annonce-create-vehicle-generic-modal>
  </div>
</template>

<script>
import api from "../../../services/api";
import AnnonceCreateVehicleGenericModal from "../../../components/annonce/AnnonceCreateVehicleGenericModal";

export default {
  name: "AnnonceCreateStep2",

  components:{
    AnnonceCreateVehicleGenericModal,
  },

  emits:["updateAnnonce"],

  props:{
    annonce : {
      required: true,
      type: Object
    }
  },

  data(){
    return {
      brands : [],
      isLoadingBrands:true,
      selectedBrand:{
        state: null,
        invalidFeedback: null,
        value: null
      },
      newBrandName: '',
      searchInput:null
    }
  },

  async mounted() {
    this.selectedBrand=this.annonce.brand
    this.$nextTick (()=>{
      this.fetchBrand()
    })
  },

  computed: {
    filteredBrands() {
      let result = [];
      this.selectedBrand.state = null;
      this.selectedBrand.invalidFeedback = null;

      if (this.searchInput) {
        result = this.brands.filter((brand) =>
          brand.name.toLowerCase().includes(this.searchInput.toLowerCase())
        );
      } else {
        result = [...this.brands];
      }

      return result;
    }
  },

  methods:{

    async fetchBrand(){
      api
        .post(`/brand/getAllActivatedByVehicleType/${this.annonce.vehicleType.value}`)
        .then(response => {
          this.brands = response.data
          this.isLoadingBrands=false
        })
        .catch(error => {
          console.error('Erreur lors de la récupération des marques', error)
          this.isLoadingBrands = false
        });
    },

    setSelectedBrand(brandId){
      if(this.selectedBrand.value!==brandId){
        this.selectedBrand.value=brandId
        this.selectedBrand.invalidFeedback=null
        this.selectedBrand.state=null
      }
      else{
        this.selectedBrand.value=null
        this.selectedBrand.invalidFeedback=null
        this.selectedBrand.state=null
      }
      this.annonce.brand = this.selectedBrand
      this.$emit('updateAnnonce', this.annonce)
    },


    getCreatedCustom(createdBaseVehicle){
      this.brands.push({...createdBaseVehicle})
      this.selectedBrand.value=createdBaseVehicle.id
    }
  },
}
</script>

<style scoped>

/* pour affichage desktop (md) : scroll pas sur la page entière mais sur le contenu modifiable uniquement */
@media (min-width: 769px) {
  #annonce-create-items-list, #annonce-create-items-list-empty, #annonce-create-items-list-loading {
    height: calc(100% - 42px);
    overflow: auto;
  }
  #annonce-create-items-list-inside {
    padding-bottom: 40px; /* place pour un peu de marge et si il y a un invalid feedback */
    margin-bottom: auto; /* si il n'y a pas assez d'items pour remplir la hauteur */
  }
  #annonce-create-items-list-empty .empty-state-container {
    min-height: 280px;
    height: unset;
    margin-top: 0px;
    padding-bottom: 40px; /* place pour un peu de marge */
    margin-bottom: auto; /* c'est pas assez grand pour remplir la hauteur */
  }
  #annonce-create-items-list-empty #empty-state-container-img-part {
    height: 140px;
  }
  #annonce-create-items-list-empty .empty-state-img {
    height: 100%;
  }
  #annonce-create-items-list-empty #empty-state-container-text-part {
    min-height: 50%;
  }
}

.item-invalid {
  border-color: var(--main-red-medium) !important;
}

#annonce-create-items-list {
  margin-left: -0.25em;
}
#annonce-create-items-list-around {
  width: 100%;
  padding-right: 0.25em;
  padding-left: 0.25em;
}
#annonce-create-items-list-inside {
  margin-left: -0.25em;
}

.item-annonce {
  margin: 0.25em;

  -ms-flex: 0 0 50%;
  -webkit-box-flex: 0;
  flex: 0 0 50%;
  max-width: calc(50% - 0.5em);
  border-radius: 10px;
  background-color: var(--main-black-medium);
  padding: 2rem;
  border: 1px solid var(--main-black-medium);
  display: flex;
  justify-content: center;
}

.item-annonce:hover {
  background-color: var(--main-black-light);
}

.item-active{
  border-color:var(--main-yellow-medium)!important;
}


.item-container-annonce{
  display: flex;
  flex-wrap: wrap;
  -ms-flex: 0 0 calc(100% + 0.5em);
  -webkit-box-flex: 0;
  width: calc(100% + 0.5em);
  max-width: calc(100% + 0.5em);
  flex: 0 0 calc(100% + 0.5em);
}


/** search bar */
.annonce-create-search-bar .search-input, .annonce-create-search-bar .search-input-append {
  background-color: transparent !important;
  border-color: var(--main-grey-dark) !important;
  color: var(--main-grey-light) !important;
}
.annonce-create-search-bar .search-input {
  position: relative;
  border-radius: var(--fourth-border-radius) !important;
  font-size: var(--content-font-size);
  padding-left: calc(1rem + 20px) !important;
}
.annonce-create-search-bar .search-input-append {
  position: absolute;
  z-index: 2;
  height: 100%;
  border-style: none;
}
.annonce-create-search-bar .search-input.active {
  border-color: var(--main-yellow-medium) !important;
}
.annonce-create-search-bar .search-input.in-error {
  border-color: var(--main-red-medium) !important;
}
</style>



// WEBPACK FOOTER //
// src/views/annonce/AnnonceCreate/AnnonceCreateStep2.vue